import React from "react";
import { Flex } from "@chakra-ui/react";
import {
    FaFileAlt,
    FaVideo,
    FaMobile,
    FaRoad,
    FaBook,
    FaUsers,
    FaQq,
    FaClock,
    FaUser,
    FaSearch,
} from "react-icons/fa";
import { ROUTES } from "constants/routes-path";
import CardList from "components/Card/CardList";

function SettingsList() {
    const settingsConfig = [
        {
            icon: FaFileAlt,
            route: ROUTES.parametersPath,
            titleKey: "settings.parameter.title",
            descriptionKey: "settings.parameter.description",
        },
        {
            icon: FaVideo,
            route: ROUTES.camerasPath,
            titleKey: "settings.camera.title",
            descriptionKey: "settings.camera.description",
        },
        {
            icon: FaMobile,
            route: ROUTES.breathalyzersPath,
            titleKey: "settings.breathalyzer.title",
            descriptionKey: "settings.breathalyzer.description",
        },
        {
            icon: FaRoad,
            route: ROUTES.equipmentsPath,
            titleKey: "settings.equipment.title",
            descriptionKey: "settings.equipment.description",
        },
        {
            icon: FaBook,
            route: ROUTES.aitBlocksPath,
            titleKey: "settings.ait-block.title",
            descriptionKey: "settings.ait-block.description",
        },
        {
            icon: FaUsers,
            route: ROUTES.usersPath,
            titleKey: "settings.user.title",
            descriptionKey: "settings.user.description",
        },
        {
            icon: FaQq,
            route: ROUTES.agentsPath,
            titleKey: "settings.agent.title",
            descriptionKey: "settings.agent.description",
        },
        {
            icon: FaClock,
            route: ROUTES.agentsSchedulesPath,
            titleKey: "settings.agent-schedule.title",
            descriptionKey: "settings.agent-schedule.description",
        },
        {
            icon: FaUser,
            route: ROUTES.personPath,
            titleKey: "settings.person.title",
            descriptionKey: "settings.person.description",
        },
        {
            icon: FaSearch,
            route: ROUTES.auditsPath,
            titleKey: "settings.audit.title",
            descriptionKey: "settings.audit.description",
        },
    ];

    return (
        <Flex
            gap="5"
            direction="column"
            pt={{ base: "180px", sm: "155px", lg: "90px" }}
            px="30px"
        >
            <CardList items={settingsConfig} />
        </Flex>
    );
}

export default SettingsList;